import { defineCatalogue } from '../../i18n';

export const shellCatalogue = defineCatalogue(
  {
    skip: 'Ir direto ao conteúdo',
    toggle: 'Abrir ou fechar a navegação',
    'nav.group.toggle': 'Mostrar ou ocultar {label}',
    'theme.label': 'Tema',
    'theme.light': 'Claro',
    'theme.dark': 'Escuro',
    'theme.system': 'Automático',
    'account.trigger': 'Configurações da conta de {name}',
    'account.settings': 'Configurações',
    'account.signOut': 'Sair',
    'settings.title': 'Configurações',
    'settings.close': 'Fechar',
    'settings.tab.account': 'Conta',
    'settings.tab.appearance': 'Aparência',
    'settings.language': 'Idioma',
    // A language names itself in its own language, so both entries carry the
    // same endonym whichever locale the reader is in.
    'settings.language.ptBR': 'Português (Brasil)',
    'settings.language.en': 'English',
    'settings.autosave': 'As alterações são salvas na hora.',
    'settings.provider.google': 'entrou com Google',
    'settings.provider.password': 'entrou com e-mail e senha',
    'settings.signOut': 'Sair da conta',
  },
  {
    skip: 'Skip to content',
    toggle: 'Open or close the navigation',
    'nav.group.toggle': 'Show or hide {label}',
    'theme.label': 'Theme',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'theme.system': 'System',
    'account.trigger': 'Account settings for {name}',
    'account.settings': 'Settings',
    'account.signOut': 'Sign out',
    'settings.title': 'Settings',
    'settings.close': 'Close',
    'settings.tab.account': 'Account',
    'settings.tab.appearance': 'Appearance',
    'settings.language': 'Language',
    'settings.language.ptBR': 'Português (Brasil)',
    'settings.language.en': 'English',
    'settings.autosave': 'Changes save automatically.',
    'settings.provider.google': 'signed in with Google',
    'settings.provider.password': 'signed in with email and password',
    'settings.signOut': 'Sign out of this account',
  },
);

export const sh = shellCatalogue.t;
